$(function ($) {
  var fadeIn = $('.fade-in');
  $(window).scroll(function () {
    $(fadeIn).each(function () {
      var offset = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > offset - windowHeight + 120) {
        $(this).addClass("scroll-in");
      }
    });
  });
});

// アンカーリンクメニュー
$('.nav_list li a[href]').on('click', function(event) {
  $('.hamburger').trigger('click');
});

// swiper
let swipeOption = {
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed: 4000,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  }
}
new Swiper('.swiper-container', swipeOption);

// Modaal
$(function() {
  $('.btn-video').modaal({
    type: 'video',
    overlay_close: 'true'
  });
});